import { ProgressBarItemSingleModified } from 'components/ProgressBar/context';
import { Check } from 'lucide-react';

import useProgressBarItemSingle from './useProgressBarItemSingle';

const ProgressBarItemSingle: React.FunctionComponent<
  Omit<ProgressBarItemSingleModified, 'type'>
> = function (props) {
  const {
    showHeader,
    showFooter,
    title,
    trackClassName,
    stepLabel,
    labelClassName,
  } = useProgressBarItemSingle(props);
  return (
    <div className="flex flex-col w-full">
      {showHeader && <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />}
      <div className="flex flex-row gap-x-4">
        <div className="flex flex-col">
          <div className={trackClassName}>
            <div className={labelClassName}>
              {stepLabel ? (
                <p className="m-auto">{stepLabel}</p>
              ) : (
                <Check size={20} className="m-auto" strokeWidth={2} />
              )}
            </div>
          </div>
          {showFooter && <div className="flex-[1_1_0] bg-neutral-300" />}
        </div>
        <div className="py-1">
          <p className="text-16-24-em text-neutral-900">{title}</p>
        </div>
      </div>
      {showFooter && <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />}
    </div>
  );
};

export default ProgressBarItemSingle;
